export { RateDetailV2 } from './RateDetailV2';
